(() => {
  class CatalogMenu extends HTMLElement {
    constructor() {
      super();
      this.onFocusIn = this.onFocusIn.bind(this);
      this.onPointerOver = this.onPointerOver.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
      this.onToggle = this.onToggle.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.parents = [...this.querySelectorAll('[data-catalog-parent]')];
      this.panels = [...this.querySelectorAll('[data-catalog-panel]')];

      if (!this.details || !this.summary) return;

      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('pointerover', this.onPointerOver);
      this.addEventListener('keydown', this.onKeyDown);
      this.details.addEventListener('toggle', this.onToggle);
      document.addEventListener('pointerdown', this.onDocumentPointerDown);

      const initialParent = this.querySelector('[data-catalog-parent].is-active') || this.parents[0];
      if (initialParent) this.activate(initialParent);

      this.onToggle();
      this.setAttribute('data-ready', '');
      this.isInitialized = true;
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('pointerover', this.onPointerOver);
      this.removeEventListener('keydown', this.onKeyDown);
      this.details?.removeEventListener('toggle', this.onToggle);
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      this.isInitialized = false;
    }

    activate(parent) {
      if (!this.parents.includes(parent)) return;

      const panel = this.panels.find((item) => item.id === parent.dataset.panelId);
      if (!panel) return;

      this.parents.forEach((item) => item.classList.toggle('is-active', item === parent));
      this.panels.forEach((item) => item.toggleAttribute('data-active', item === panel));
    }

    onFocusIn(event) {
      const parent = event.target.closest?.('[data-catalog-parent]');
      if (parent) this.activate(parent);
    }

    onPointerOver(event) {
      const parent = event.target.closest?.('[data-catalog-parent]');
      if (parent) this.activate(parent);
    }

    onToggle() {
      const isOpen = Boolean(this.details?.open);
      this.summary?.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) document.dispatchEvent(new Event('catalog-menu:open'));
    }

    onDocumentPointerDown(event) {
      if (this.details?.open && !this.contains(event.target)) this.details.open = false;
    }

    onKeyDown(event) {
      if (event.key !== 'Escape' || !this.details?.open) return;

      event.preventDefault();
      this.details.open = false;
      this.summary.focus();
    }
  }

  if (!customElements.get('catalog-menu')) customElements.define('catalog-menu', CatalogMenu);
})();
